'use client';

import { Session } from 'next-auth';
import { SessionProvider, useSession } from 'next-auth/react';
import { NuqsAdapter } from 'nuqs/adapters/next/app';
import { PropsWithChildren, useEffect, useState } from 'react';

import { TooltipProvider } from 'components/ui/tooltip';

import { QueryProvider } from 'hooks/query';

import { TokenProvider, useToken } from './components/provider/token-provider.tsx';
import GlobalStyles from './components/ui/global/Global';
import { Toaster as ToasterSonner } from './components/ui/sonner.tsx';
import ThemeProvider from './components/ui/theme/ThemeProvider';
import { DarkModeThemeProvider } from './components/ui/theme/dm-theme-provider';
import { updateTokenCache } from './lib/authProvider.ts';
import { logYellow } from './utils/debugger';

// todo show loader until loaded
export function AppWithConfigInjected({ children }: PropsWithChildren) {
  const [loaded, setLoaded] = useState(false);
  const { updateTokenState } = useToken();

  const { data: session } = useSession();

  async function updateConfigAndToken() {
    const res = await fetch('/api/config');
    const data = await res.json();
    console.log('clientConfig', data);
    global.clientConfig = data;
    const token = global.clientConfig.jwtToken;
    updateTokenCache(token); // axios/signalR use this
    updateTokenState(token); // for react components use this - should only be used by the unity apps!

    if (!loaded) setLoaded(true);
  }

  useEffect(() => {
    if (!session) return;
    logYellow('session changed - update token cache', session, new Date(session.expires));
    // inject client side config
    updateConfigAndToken();
  }, [session]);

  // todo show loading spinner,
  if (!loaded) return null;

  return children;
}

export function AllToolingProviders({
  children,
  session,
}: PropsWithChildren<{ session: Session | null }>) {
  return (
    <ThemeProvider>
      <DarkModeThemeProvider defaultTheme="dark">
        <GlobalStyles />
        <SessionProvider refetchInterval={30} session={session}>
          <TokenProvider>
            <NuqsAdapter>
              <QueryProvider>
                <>
                  <TooltipProvider delayDuration={0}>
                    {children}
                    <ToasterSonner />
                    {/* <DevTools /> */}
                  </TooltipProvider>
                </>
              </QueryProvider>
            </NuqsAdapter>
          </TokenProvider>
        </SessionProvider>
      </DarkModeThemeProvider>
    </ThemeProvider>
  );
}
